import React from "react";
import css from './Login.module.scss'
import { NavLink } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useState } from "react";
import axios from '../../../Axios/Default'
import { useNavigate } from "react-router-dom";
import { DoLoginAdmin } from "../../../Services/Admin/AuthAdminSevices";

const AdminLoginPage = () => {

  const {register, handleSubmit, formState: { errors }, setError} = useForm({defaultValues: {username: "",password: ""}});
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  
  const [state, setNewState] = useState({ 
    isStarted: false,
    isVisible: false, 
    isBackdrop: false, 
    title: '', 
    content: <div></div>, 
    background: '',
    loginError: false
  });

  const setState = data => {
    setNewState(prevState => ({ ...prevState, ...data }));
  }

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  function onSubmit(data) {
    if (!data.username) {
      setError("username", {
        type: "manual",
        message: "Email or Username is required",
      });
    }
      // alert('asd')
    
    DoLoginAdmin(data).then((result) => {
      localStorage.clear();
      
      localStorage.setItem("username_admin", result.data.username);
      localStorage.setItem("role_code_admin", result.data.role_code);
      localStorage.setItem("access_token_admin", result.data.access_token);
      localStorage.setItem("refresh_token_admin", result.data.refresh_token);
      
      
      axios.defaults.headers.common["Authorization"] = `Bearer ${result.data.access_token}`;
      // navigate("/admin/dashboard");
      window.location.href = "dashboard";
      // alert('asd')
    }).catch(({ response }) => {
      // console.log(response)
      // if(response.status === 401){
        setState({ loginError: true });
      // }
    });
  }

  
  const { isStarted, isVisible, isBackdrop, title, content, background, loginError } = state;

  return (
    <div className="row vh-100">
        <div className="col-md-6 h-100 " style={{ backgroundImage: "url('/monitoring/MonitoringAssets/left-bg.png')", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition:'center' }}></div>
        <div className="col-md-6 h-100 d-flex justify-content-center align-items-center">
          
            <div className={css.login_wrap}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <img src="/monitoring/MonitoringAssets/Logo.png" className={css.logo} />
                <div className={css.form_group}>
                  <p>Sign In</p>
                  <b>Email</b>
                  <input type="text" placeholder="Username" 
                    {...register("username", {
                      required: {
                        value: true,
                        message: "Email or Username is required",
                      },
                    })}
                  />
                  <b>Password</b>
                  <input type={showPassword ? "text" : "password"} placeholder="Password" 
                    {...register("password", {
                      required: {
                        value: true,
                        message: "Password is required",
                      },
                    })}
                  />
                  {showPassword ? (
                    <img src="/monitoring/MonitoringAssets/Eye.svg" className={css.eye_password} onClick={toggleShowPassword} />
                  ) : (
                    <img src="/monitoring/MonitoringAssets/EyeClose.svg" className={css.eye_password} onClick={toggleShowPassword} />
                  )}
                  
                  {loginError == true && (
                    <span className="text-danger error_message">
                      Login failed! Enter the correct username and password.
                    </span>
                  )}
                  <button>Sign In</button>
                </div>            
              </form>
            </div>
        </div>
    </div>
  );
};

export default AdminLoginPage;
